import './Segmented.css'

interface SegmentedProps<T extends string> {
  label: string
  value: T
  options: { value: T; label: string }[]
  onChange: (value: T) => void
  /** Fills its row with equal segments, as the Status control does. */
  fill?: boolean
}

/** A segmented control: one selected segment on a track. */
export function Segmented<T extends string>({ label, value, options, onChange, fill = false }: SegmentedProps<T>) {
  return (
    <div className={`seg ${fill ? 'seg--fill' : ''}`} role="group" aria-label={label}>
      {options.map((o) => (
        <button
          type="button"
          key={o.value}
          className={`seg__opt ${o.value === value ? 'seg__opt--on' : ''}`}
          aria-pressed={o.value === value}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  )
}
